import { useLinesVodGenresStore } from "@/stores/LinesVodGenres";
import { useMultiLinesVodGenresStore } from "@/stores/MultiLinesVodGenres";
import { useMostPopularVod } from "@/stores/MostPopularVod";

const {
	clearIndexMostPopular,
} = useMostPopularVod();

const {
	clearAllLinesVodGenresStore
} = useLinesVodGenresStore();
const {
	clearMultiLinesVodGenres
} = useMultiLinesVodGenresStore();

export default defineNuxtRouteMiddleware(() => {
	if (import.meta.client) {
		clearAllLinesVodGenresStore();
		clearIndexMostPopular();
		clearMultiLinesVodGenres();
	}
});